import React, {Component} from 'react';
import {connect} from 'react-redux';
import TemporalNavigator from './TemporalNavigator';

class Footer extends Component {
  render() {
    const { graphs_open, graph_view_expanded, point_data_display_graph } = this.props;
    const hide_footer = graphs_open && graph_view_expanded && point_data_display_graph;
    return !hide_footer ? <div className="footer"><TemporalNavigator/></div> : null;
  }
}

const mapStateToProps = state => {
  return {
    graphs_open: state.view.graphs_open,
    graph_view_expanded: state.view.graph_view_expanded,
    point_data_display_graph: state.view.point_data_display_graph
  };
};

Footer = connect(mapStateToProps)(Footer);

export default Footer;


// WEBPACK FOOTER //
// ./src/containers/Footer.js